<template>
    <v-container fluid class="pa-0 responsive mb-16">
        <div class="plans__cards mb-4" :style="{ background: data.pallete.headColor }">
            <button @click="toggleCard" class="circle-btn-nave"><i class="fa fa-share-alt"></i></button>
            <a class="card__title"
                ><span class="my-text" :style="{ color: data.pallete.textColor }">{{ data.companyName }}</span>
            </a>
            <!-- Card1 -->
            <div class="card my-element" v-if="IsShowCardSection1">
                <!-- <button class="circle-btn"><i class="fa fa-share-alt"></i></button> -->
                <div class="card__header card__header--blue">
                    <div class="card__clouds card__clouds--paper-plane">
                        <i class="fas fa-cloud"></i>
                        <i class="fas fa-cloud"></i>
                        <i class="fas fa-cloud"></i>
                    </div>
                </div>
                <div class="card__plan-box" :style="{ background: data.pallete.headColor }">
                    <h4 class="card__plan-title">
                        <span class="text-20" :style="{ color: data.pallete.textColor }">{{ data.titleDiscount }}</span>
                    </h4>
                </div>
                <span class="card__paper-plane fas fa-paper-plane" :style="{ color: data.pallete.headColor }"></span>
                <div class="card__content">
                    <ul class="card__lists">
                        <li class="card__list mt-10 my-text">{{ data.titleCompany }}</li>
                        <li class="card__list px-2">{{ data.descriptionDiscount }}</li>
                        <li class="card__list px-2">{{ data.location }}</li>
                    </ul>
                </div>
                <a @click="ShowCard2" class="btn btn-fix btn__shape btn__shape--purple card__link m-5" :style="{ background: data.pallete.bodyColor }">
                    <span>{{ data.giveCopan }}</span></a
                >
            </div>
            <!-- Card2 -->

            <div class="card my-element" v-if="IsShowCardSection2">
                <!-- <button class="circle-btn"><i class="fa fa-share-alt"></i></button> -->
                <a @click="ShowCard1" class="card__close"><i class="fas fa-window-close"></i></a>

                <div class="card__content">
                    <ul class="card__discount">
                        <li class="card__list mt-20 text-40">کد کوپن</li>
                        <li class="card__list my-text text-danger">{{ data.titleDiscount }}</li>

                        <li class="card__list mt-20 text-20">اعتبار تا 15 ژوئن 2023</li>
                        <li class="w-50">
                            <a class="btn btn-fix btn__shape--transparent card__link" v-if="!IsCopy" @click="toggleCopy"> <span>کد را کپی کنید </span></a>
                            <a class="btn btn-fix btn__shape--transparent card__link" v-if="IsCopy"> <span> کپی شد </span></a>
                        </li>
                    </ul>
                </div>
                <a class="btn btn-fix btn__shape card__link mt-8" :style="{ background: data.pallete.bodyColor }"> <span> تکمیل خرید</span></a>
                <!-- <a class="btn btn-fix btn__shape btn__shape--green card__link"> <span> مشاهده مکان</span></a> -->
            </div>

            <!-- CardSocial -->

            <div class="card my-element--header my-element--social--color hidden-card" :class="{ 'show-card': showCard, 'hidden-card': !showCard }">
                <!-- <button class="circle-btn"><i class="fa fa-share-alt"></i></button> -->
                <a @click="toggleCard" class="card__close"><i class="fas fa-window-close"></i></a>
                <div class="w-100 my-element--social">
                    <div class="w-100 mt-20 flex">
                        <v-list-item link v-for="(item, index) in computeFields" :key="index" @click="goToUrl(item.url, item.pattern)">
                            <v-list-item-icon>
                                <v-btn icon dark>
                                    <img :src="item.img" alt="" class="img-fluid" />
                                </v-btn>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <!--                        {{ item.pattern }}-->
                                <v-list-item-title v-text="item.label" />
                            </v-list-item-content>
                        </v-list-item>
                    </div>
                </div>
            </div>
            <!-- openMap -->
        </div>
    </v-container>
</template>

<script>
import { Bus } from "../../../../main";
export default {
    name: "qrDiscount",
    props: {
        data: {
            default: {},
        },
    },
    data() {
        return {
            pallete: {
                headColor: "linear-gradient(to right , #f6ae42, #f13030) ",
                bodyColor: "linear-gradient(to top left , #001554, #8bfbfd) ",
                textColor: "#ffffff",
                borderColor: "#ffffff",
            },
            IsShowCardSection1: true,
            IsShowCardSection2: false,
            IsCopy: false,

            showCard: false,
        };
    },
    methods: {
        ShowCard2() {
            this.IsShowCardSection1 = false;
            this.IsShowCardSection2 = true;
        },
        ShowCard1() {
            this.IsShowCardSection1 = true;
            this.IsShowCardSection2 = false;
        },
        toggleCard() {
            this.showCard = !this.showCard;
        },
        toggleCopy() {
            this.IsCopy = !this.IsCopy;
        },
        openMap() {
            let agent = window.navigator.userAgent;
            let type = "https://www.google.com/maps/@";

            if (agent.toLowerCase().search("android") > 0) {
                type = "geo:";
            } else if (agent.search("iPad") > 0 || agent.search("iPhone") > 0 || agent.search("iPod") > 0) {
                type = "maps:";
            }

            window.open(`${type}${this.data.coordinates[1]},${this.data.coordinates[0]}?q=${this.data.coordinates[1]},${this.data.coordinates[0]}`, "_blank");
        },
    },
    computed: {
        thirdOne() {
            let top = {};

            Object.entries(this.data.socialMedia)
                .slice(0, 1)
                .forEach(([x, y]) => {
                    top[x] = y[0];
                });

            return top;
        },
        computeFields() {
            let extra = [];

            Object.entries(this.data.socialMedia).forEach(([x, y]) => {
                extra.push(...y);
            });

            Object.values(this.thirdOne).forEach((x) => {
                extra = extra.filter((item) => item !== x);
            });

            return extra;
        },
    },
    watch: {
        pallete: {
            handler() {
                Bus.$emit("colorPalette", this.pallete);
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.data.isGradient = true;
        this.data.pallete = {
            headColor: "linear-gradient(to right , #f6ae42, #f13030) ",
            bodyColor: "linear-gradient(to top left , #001554, #8bfbfd) ",
            textColor: "#ffffff",
            borderColor: "#ffffff",
        };

        Bus.$on("colorUpdate", (value) => {
            // this.pallete.headColor = value.headColor;
            // this.pallete.bodyColor = value.bodyColor;
            this.pallete.textColor = value.textColor;
        });

        Bus.$on("headColor", (value) => {
            this.pallete.headColor = `linear-gradient(${value.dir} , ${value.color1}, ${value.color2})`;
        });

        Bus.$on("bodyColor", (value) => {
            this.pallete.bodyColor = `linear-gradient(${value.dir} , ${value.color1}, ${value.color2})`;
        });

        Bus.$on("gradientType", (value) => {
            this.isGradient = value;
        });

        Bus.$on("bordersColor", (value) => {
            this.pallete.borderColor = value;
        });

        Bus.$on("showMe", (value) => {
            if (this.data?.photo.hasWelcome) {
                this.showWelcome = true;
                this.locationPage = false;
                setTimeout(() => {
                    this.locationPage = false;
                    this.showWelcome = false;
                }, 3000);
            }
        });
    },
};
</script>

<style scoped>
@-webkit-keyframes fade-in {
    to {
        opacity: 1;
    }
}

@keyframes fade-in {
    to {
        opacity: 1;
    }
}

@-webkit-keyframes fade-out {
    to {
        opacity: 0;
    }
}

@keyframes fade-out {
    to {
        opacity: 0;
    }
}
@-webkit-keyframes paper-plane-flying {
    25% {
        top: 6rem;
        left: 16rem;
        -webkit-transform: rotateZ(-80deg);
        transform: rotateZ(-80deg);
    }
    100% {
        top: -1rem;
        left: -3rem;
        -webkit-transform: rotateZ(-90deg);
        transform: rotateZ(-90deg);
    }
}

@keyframes paper-plane-flying {
    25% {
        top: 6rem;
        left: 16rem;
        -webkit-transform: rotateZ(-80deg);
        transform: rotateZ(-80deg);
    }
    100% {
        top: -1rem;
        left: -3rem;
        -webkit-transform: rotateZ(-90deg);
        transform: rotateZ(-90deg);
    }
}

@keyframes scale-in {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes scale-out {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}

li {
    list-style: none;
}
.responsive {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.plans__cards {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    margin: 0;
    width: 100%;
    padding-top: 6rem;
    padding-bottom: 2rem;
}

.card {
    position: relative;
    overflow: hidden;
    width: calc(100% - 2.5rem);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-shadow: -5px 5px 15px 1px rgba(201, 200, 200, 0.1);
    background-color: white;
    border-radius: 1rem;
}

.card__header {
    width: 100%;
    height: 23rem;
}
.card__header--blue {
    background: linear-gradient(110deg, #001554 -1.13%, #2608bf 15.22%, #3d64ff 32.09%, #67c9ea 48.96%, #bbebf6 67.94%, #3d66f9 85.34%);
}

.card__clouds {
    position: relative;
    width: 100%;
    height: 80%;
    overflow: hidden;
}

.card__clouds > * {
    position: absolute;
    color: white;
}

.card__clouds :nth-of-type(1) {
    top: 38%;
    left: 10%;
    font-size: 7rem;
    opacity: 0.8;
}

.card__clouds :nth-of-type(2) {
    top: 50%;
    left: 77%;
    font-size: 5rem;
    opacity: 0.6;
}
.card__clouds :nth-of-type(3) {
    top: 10%;
    left: 46%;
    font-size: 3rem;
    opacity: 0.3;
}
.card__plan-box {
    position: absolute;
    top: 13rem;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10rem;
    height: 10rem;
    overflow: hidden;
    cursor: pointer;

    border: 0.5rem solid #f1f1f1;
    border-radius: 50%;
}

.card__plan-title {
    text-align: center;
    width: 100%;
    padding: 0.5rem;
}

.card:hover .card__plan-title {
    -webkit-animation: fade-out 0.3s ease forwards, fade-in 0.3s ease 2.3s forwards;
    animation: fade-out 0.3s ease forwards, fade-in 0.3s ease 2.3s forwards;
}

.card__paper-plane {
    position: absolute;
    z-index: 2;
    top: 16rem;
    left: 42%;
    font-size: 4rem;
    color: #457b9d;
    opacity: 0;
}

.card:hover .card__paper-plane {
    opacity: 1;
    -webkit-animation: paper-plane-flying 2s 0.5s ease-out forwards;
    animation: paper-plane-flying 2s 0.5s ease-out forwards;
}

.card__content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: -3rem;
    background-color: white;
    border: 0.2rem solid #f1f1f1;
    border-top-width: 0.5rem;

    border-top-left-radius: 2.5rem;
    border-top-right-radius: 2.5rem;
}

.card__lists {
    margin: 0 0.5rem;
    padding: 0;
    overflow-y: scroll;
    scroll-margin: 0;
    overflow-x: hidden;

    width: 100%;
    height: 20rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    opacity: 0.7;
}
.card__discount {
    margin: 0 2rem;

    width: 100%;
    height: 40rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    opacity: 0.7;
}

.card__lists::-webkit-scrollbar {
    display: none;
}
.v-application ol,
.v-application ul {
    padding-left: 0px !important;
}

.card__list {
    width: 100%;
    padding: 1rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    border-bottom: 1px solid rgba(68, 68, 68, 0.1);
}

.card__list:last-child {
    border-bottom: 0;
}

.card__list--price {
    font-size: 3rem;
    margin: 4rem 0 0 0;
    border: 2px solid rgba(68, 68, 68, 0.4);
    border-radius: 0.5rem;
    background-color: rgba(248, 7, 7, 0.422);
    color: #f1f1f1;
    text-shadow: 2px 1px 4px #444444;
}

.btn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    padding: 1rem;
    margin: 1rem 0;
    font-size: 1.2rem;
    font-weight: bold;
    border: none;
    outline: none;
    border-radius: 1rem;
    cursor: pointer;
    box-shadow: 0 0 3px #444444;
    overflow: hidden;
    -webkit-transform: all 0.3s ease;
    transform: all 0.3s ease;
}
.btn-fix {
    width: 90%;
    height: 3.6rem;
}

.btn__shape {
    color: white;
    padding: 1.1rem 4rem 1.1rem 4rem;
}

.btn__shape--transparent {
    background: #ffffff2e;
    color: #44444460;
}

.btn__shape--orange {
    background-color: #d35400;
}
.btn__shape--green {
    background-color: rgb(27, 141, 57);
}
.btn__shape--purple::before {
    content: "\f541";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    position: absolute;
    top: 0.5rem;
    left: 1rem;
    font-size: 2rem;
    -webkit-transform: rotateY(-0.5turn);
    transform: rotateY(-0.5turn);
    opacity: 0;
    transition: all 0.3s linear;
}

.btn__shape--purple::after {
    content: "\f51e";
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
    position: absolute;
    top: 0.5rem;
    left: 1rem;
    font-size: 2rem;
    opacity: 1;
    transition: all 0.3s linear;
}

.btn__shape:hover::after {
    -webkit-transform: rotateY(0.5turn);
    transform: rotateY(0.5turn);
    opacity: 0;
}

.btn__shape:hover::before {
    -webkit-transform: rotateY(0);
    transform: rotateY(0);
    opacity: 1;
}

.card__link {
    margin: 0.5rem;
}

.card__title {
    position: absolute;
    max-width: 20rem;
    top: 0;
    right: 0;
    height: 3.6rem;
    color: rgb(13, 13, 13);
    z-index: 1000;
    text-decoration: none;
    padding: 1rem 2rem;
    margin: 1rem;
    border: none;
    outline: none;
    cursor: pointer;
    overflow: hidden;
    -webkit-transform: all 0.3s ease;
    transform: all 0.3s ease;
}
.card__title span {
    font-size: 2rem;
}

.circle-btn-nave {
    position: absolute;
    top: 1rem;
    left: 2rem;
    background: transparent;
    border: none;
    color: white;
    font-size: 3rem;
    font-weight: bold;
    cursor: pointer;
    /* transition: 5s all ease-in-out; */
}

.circle-btn-nave i {
    font-size: 3rem;
    color: white;
}

.my-element {
    height: 46rem;
}
.my-element--social--color {
    background: linear-gradient(110deg, #fdfdfd -1.13%, #a3fff1 15.22%, #1486ff 32.09%, #001554 85.34%);
}
.my-element--header {
    width: calc(100% - 5rem);
    position: absolute;
    min-height: 20rem;
    z-index: 10000;
    display: flex;
    justify-content: center;
    align-items: center;
 
    max-height: 50%;
}
.my-element--social {
    transform-origin: 0 0;
       overflow-y: scroll;
    overflow-x: hidden;
    scroll-margin: 0 !important;
}

.my-element--social::-webkit-scrollbar {
    width: 0.4em;
}

.scale-enter-active {
    animation: scale-in 0.5s;
}

.scale-leave-active {
    animation: scale-out 0.5s;
}

.text-40 {
    font-size: 40px;
}
z-100 {
    z-index: 100;
}

.text-30 {
    font-size: 30px;
}
.text-20 {
    font-size: 20px;
    font-weight: bolder;
}

.card__close {
    position: absolute;
    left: 0rem;
    top: 1.5rem;
    margin: 0 2rem;
    z-index: 20;

    transition: all 0.3s ease;
}
.card__close i {
    font-size: 3rem;
    color: #d35400;
}

.hidden-card {
    opacity: 0;
    transform: scale(0) rotate(10deg);

    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.show-card {
    opacity: 1;
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
    transform: scale(1);
}

.my-text {
    font-size: 26px;
    font-weight: bold;
    perspective: 1000px;
    transform-style: preserve-3d;
    transform: translateZ(-25px) rotateY(45deg);

    text-align: center;
    line-height: 1;
}
</style>
